import React, { useState } from 'react';
import FullScreenAnalysis from './FullScreenAnalysis';

const AddressDetailsMode = ({ onStartAnalysis }) => {
    const [address, setAddress] = useState('');
    const [showFullScreen, setShowFullScreen] = useState(false);

    const handleFetchDetails = async () => {
        if (!address.trim()) return;

        // Directly open fullscreen modal instead of fetching data for preview
        setShowFullScreen(true);
    };

    return (
        <div className="address-mode">
            <div className="address-input-section">
                <h3>Property Address Lookup</h3>
                <div className="address-input" style={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center'
                }}>
                    <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Enter property address..."
                        onKeyPress={(e) => e.key === 'Enter' && handleFetchDetails()}
                        style={{
                            flex: '1',
                            minWidth: '300px',
                            padding: '16px 20px',
                            fontSize: '16px',
                            border: '2px solid #d1d5db',
                            borderRadius: '12px',
                            outline: 'none',
                            transition: 'all 0.3s ease'
                        }}
                        onFocus={(e) => {
                            e.target.style.borderColor = '#3b82f6';
                            e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = '#d1d5db';
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                        <button 
                        onClick={handleFetchDetails} 
                        disabled={!address.trim()}
                        style={{
                            padding: '16px 18px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            background: 'black',
                            color: 'white',
                            border: 'none',
                            borderRadius: '12px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                           
                            minWidth: '120px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                           
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                            
                        }}
                    >
                        🔍 Analyze
                        </button>
                </div>
            </div>

            {/* Show simplified preview instead of full data */}
            <div style={{
                textAlign: 'center',
                padding: '40px 20px',
                background: '#f9fafb',
                borderRadius: '12px',
                border: '2px solid #e5e7eb',
                margin: '20px 0'
            }}>
                <div style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#374151',
                    marginBottom: '12px'
                }}>
                    🏢 Ready for Complete Analysis
                </div>
                <div style={{
                    fontSize: '16px',
                    color: '#6b7280',
                    marginBottom: '20px'
                }}>
                    Click the button above to get comprehensive property analysis with:
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '16px',
                    marginTop: '20px'
                }}>
                    <div style={{
                        padding: '16px',
                        background: 'white',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>🏠</div>
                        <div style={{ fontWeight: 'bold', color: '#1f2937' }}>Property Details</div>
                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Owner, zoning, financials</div>
                        </div>
                    <div style={{
                        padding: '16px',
                        background: 'white',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>🏪</div>
                        <div style={{ fontWeight: 'bold', color: '#1f2937' }}>Competitor Analysis</div>
                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Photos, amenities, ratings</div>
                        </div>
                    <div style={{
                        padding: '16px',
                        background: 'white',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb'
                    }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px' }}>⚠️</div>
                        <div style={{ fontWeight: 'bold', color: '#1f2937' }}>Safety Alerts</div>
                        <div style={{ fontSize: '14px', color: '#6b7280' }}>Churches, schools nearby</div>
                        </div>
                        </div>
                    </div>

            {/* Full Screen Analysis Modal - Will fetch all data internally */}
            {showFullScreen && (
                <FullScreenAnalysis
                    address={address}
                    onClose={() => setShowFullScreen(false)}
                />
            )}

        </div>
    );
};

export default AddressDetailsMode;